<template>
  <div class="Header">
      <div class="logo" @click="onLogo" />
      <div class="Header-hamburger" @click="open = !open" :class="open ? 'open': 'close'" />

    <transition name="slide">
      <div v-if="open" class="Header-menu">
        <div class="Header-wrapper">
          <div class="btns">
            <button
              @click="onDownLoad"
              class="download"
              :disabled="!isLogin">プリダウンロード</button>
            <button
              @click="onProfile"
              class="member"
              :disabled="!isLogin">会員証</button>
            <button
              @click="onAlbum"
              class="album"
              :disabled="!isLogin">アルバム</button>
            <button @click="onNews" class="news" :disabled="!isLogin">みんなへのお知らせ</button>
            <button @click="onMessage" class="message" :disabled="!isLogin">あなたへのお知らせ</button>
            <button @click="onCoupon" class="coupon" :disabled="!isLogin">クーポン</button>
            <button @click="onApp" class="motto">アプリ</button>
            <button
              @click="onMemberBenefits"
              class="memberBenefits"
              :disabled="!isLogin">有料会員登録</button>
            <button
              @click="onSetting"
              class="setting"
              :disabled="!isLogin">プロフィール設定</button>
          </div>
          <div class="btns">
            <button class="text" v-if="isLogin" @click="onLogout">ログアウト</button>
            <button v-else class="login" @click="onLogin">ログイン</button>
            <button class="text" @click="onTermsOfUse">利用規約</button>
            <button class="text" @click="onHelp">ヘルプ</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  path: "Header",
  data () {
    return {
      open: false
    }
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    },
    path: {
      path: String,
      require: true
    }
  },
  computed: {
  },
  methods: {
    onLogo() {
      if (this.$route.path !== '/') {
        this.push('/')
      }
    },
    onPaidMemberChange() {
      this.push('/PaidMemberChange')
    },
    onDownLoad() {
      this.push('/download')
    },
    onProfile() {
      this.push('/member')
    },
    onAlbum() {
      this.push('/album')
    },
    onCoupon() {
      this.push('/couponList');
    },
    onNews() {
      this.push('/newsList')
    },
    onMessage() {
      this.push('/messageList')
    },
    onApp() {
      this.push('/Application')
      sessionStorage.setItem('prevPage', '/');
    },
    onSetting() {
      this.push('/setting')
    },
    onMemberBenefits() {
      this.push('/MemberBenefits')
    },

    onLogin() {
      this.push('/login')
    },
    onLogout() {
      this.push('/logout')
    },
    onTermsOfUse() {
      // 戻るボタンやホームへ戻るボタン表示のため
      if(this.$route.path !== '/terms'){
        sessionStorage.setItem('termsReferrer', this.$route.path)
        sessionStorage.setItem('termsFullReferrer', this.$route.fullPath)
      }
      this.push('/terms')
    },
    onHelp() {
      this.push('/help')
      sessionStorage.setItem('prevPage', '/');
    },

    push(path) {
      if (this.$route.path !== path) {
        this.open = false
        this.$router.push(path)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.Header {
  background: #FBFCFD;
  height: 45px;
  border-bottom: 1px solid #58575733;
  position: relative;
  &-hamburger {
    position: absolute; 
    top: 0;
    right: 30px;
    width: 45px;
    height: 45px;
    background-image:
      linear-gradient(to right, #8D7F81, #8D7F81),
      linear-gradient(to right, transparent 40%, #8D7F81 41%, #8D7F81 100%),
      linear-gradient(to right, transparent 20%, #8D7F81 21%, #8D7F81 100%);
    background-repeat: no-repeat;
    background-size: 35px 1px;
    background-position: 5px 17px, 5px 22px, 5px 27px;
    transition: .15s;
    cursor: pointer;
    &.open {
      background-image:
        linear-gradient(20deg, transparent 0%, transparent 44%, #8D7F81 50%, transparent 55%),
        linear-gradient(160deg, transparent 0%, transparent 44%, #8D7F81 50%, transparent 55%);
      background-repeat: no-repeat;
      background-size: 28px 10px;
      background-position: 10px 17px, 10px 17px;
    }
  }
  &-menu {
    position: fixed;
    top: 45px;
    overflow-x: hidden;
    width: 375px;
    height: calc(100% - 45px);
  }
  &-wrapper {
    overflow-y: scroll;
    padding: 0 90px 20px 45px;
    width: 392px;
    height: 100%;
    background-color: #FBFCFD;
    &::after {
      content: "";
      display: block;
      position: absolute;
      width: 45px;
      right: 0;
      height: 100%;
      top: 0;
      background-color: #00000099;
    }
    .btns {
      margin-top: 20px;
      padding-bottom: 10px;
      &:first-of-type { border-bottom: 1px solid #C7C9CA66; }
      button {
        width: 100%;
        text-align: left;
        padding: 15px 0 15px 50px;
        font-size: 14px;
        color: #8D7F81;
        background-size: 30px;
        background-position: left center;
        outline: none;
        &:not(:disabled) {
          &:active { color: #EF2562; }
        }
        &.download {
          background-image: url(../assets/Png/nav/ic_dl.png);
          &:active { background-image: url(../assets/Png/nav/ic_dl_active.png); }
          &:disabled { background-image: url(../assets/Png/nav/ic_dl_disabled.png) }
        }
        &.member {
          background-image: url(../assets/Png/nav/ic_member.png);
          &:active { background-image: url(../assets/Png/nav/ic_member_active.png); }
          &:disabled { background-image: url(../assets/Png/nav/ic_member_disabled.png) }
        }
        &.album {
          background-image: url(../assets/Png/nav/ic_album.png);
          &:active { background-image: url(../assets/Png/nav/ic_album_active.png); }
          &:disabled { background-image: url(../assets/Png/nav/ic_album_disabled.png) }
        }
        &.news {
          background-image: url(../assets/Png/nav/ic_news.png);
          &:active { background-image: url(../assets/Png/nav/ic_news_active.png); }
          &:disabled { background-image: url(../assets/Png/nav/ic_news_disabled.png) }
        }
        &.message {
          background-image: url(../assets/Png/nav/ic_message.png);
          &:active { background-image: url(../assets/Png/nav/ic_message.png); }
          &:disabled { background-image: url(../assets/Png/nav/ic_message_disabled.png) }
        }
        &.coupon {
          background-image: url(../assets/Png/nav/ic_coupon.png);
          &:disabled { background-image: url(../assets/Png/nav/ic_coupon_disabled.png) }
        }
        &.motto {
          background-image: url(../assets/Png/nav/ic_purimotto.png);
          &:disabled { background-image: url(../assets/Png/nav/ic_purimotto_disabled.png) }
        }
        &.setting {
          background-image: url(../assets/Png/nav/ic_settings.png);
          &:disabled { background-image: url(../assets/Png/nav/ic_settings_disabled.png) }
        }
        &.memberBenefits {
          background-image: url(../assets/Png/nav/ic_paidmember.png);
          &:disabled { background-image: url(../assets/Png/nav/ic_paidmember_disabled.png) }
        }
        &.login {
          background-image: url(../assets/Png/nav/ic_login.png);
          &:disabled { background-image: url(../assets/Png/nav/ic_login_disabled.png) }
        }
        &:disabled { color: rgba(141, 127, 129, 0.35); }
        &.text {
          width: 100%;
          padding: 10px 0;
          text-align: left;
          font-size: 12px;
          color: #373737;
        }
      }
    }
  }
}

.slide-enter-active {
    transition: all .2s linear;
    opacity: 1;
}
.slide-leave-active {
    transition: all .2s linear;
    opacity: 1;
}
.slide-enter, .slide-leave-to {
    opacity: 0;
}

.logo {
  width: 100px;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-image: url(../assets/Png/Common/image_logo_purikuraon.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.loginButton {
  border: 2px solid lightgrey;
  border-radius: 18px;
  font-size: 10px;
  font-weight: bold;
  line-height: 32px;
  margin-right: 16px;
  padding: 0px 15px;
}
.loginButton:active {
  transform: scale(0.95);
}
</style>
